<!--
    描述：新增、编辑人员弹框等
    时间：2020-04-22
    Created by yefan
-->
<template>
	<div class="h100 add-user-main">
		<el-form :model="userForm"
				 :rules="userRules"
				 ref="userForm"
				 label-width="100px">
			<el-row>
				<el-col :span="24">
					<el-form-item label="姓名"
								  prop="sname"
								  :show-message="false">
						<el-input v-model="userForm.sname"
								  :disabled="isDisabled"
								  autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="用户名"
								  prop="username"
								  :show-message="false">
						<el-input v-model="userForm.username"
								  :disabled="isDisabled"
								  autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="手机号"
								  prop="phone"
								  :show-message="false">
						<el-input v-model="userForm.phone"
								  :disabled="isDisabled"
								  autocomplete="off"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<!--			<el-row>
				<el-col :span="24">
					<el-form-item label="用户组"
								  prop=""
								  :show-message="false">
						<el-select v-model="userForm.groupIds"
								   multiple
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in groups"
									   :key="'类型' + index"
									   :label="item.sname"
									   :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>-->

			<el-row>
				<el-col :span="24">
					<el-form-item label="岗位"
								  prop="stationId">
						<el-select v-model="userForm.stationId"
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in stationList"
									   :key="'类型' + index"
									   :label="item.sname"
									   :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="账号状态"
								  prop="orEnable">
						<el-switch v-model="userForm.orEnable"
								   active-text="启用"
								   inactive-text="禁用"
								   :active-value="1"
								   :inactive-value="0"
								   :disabled="isDisabled"></el-switch>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="角色"
								  :show-message="false">
						<el-select v-model="userForm.roleIds"
								   multiple
								   :disabled="isDisabled"
								   placeholder="请选择">
							<el-option v-for="(item, index) in roleTreeData"
									   :key="'类型' + index"
									   :label="item.label"
									   :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

	</div>
</template>
<script>
import {
	insertSysUser,
	getUserInfo,
	saveOrUpdatePlatformUser,
} from 'api/system/user.js'
import { selectRoleTree } from 'api/system/role.js'
import { getDictsByValue, getAllGroups } from 'api/system/group.js'
import { getItem } from '@/utils/storage.js'
export default {
	components: {},
	props: {
		transObj: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			userForm: {
				sname: '',
				phone: '',
				username: '',
				groupIds: [],
				parentId: '',
				stationId: '',
				orEnable: 1,
				roleIds: [],
			},
			userRules: {
				sname: [{ required: true }],
				username: [{ required: true }],
				phone: [{ required: true }],
				roleIds: [{ required: true, type: 'array', trigger: 'change' }],
			},
			roleTreeData: [],
			defaultProps: {
				children: 'children',
				label: 'sname',
			},
			dialogObj: {
				title: '选择上级领导',
				visible: false,
				width: '650px',
				mode: 'add',
			},
			stationList: [],
			groups: [],
		}
	},
	methods: {
		//点击确定按钮事件
		doSave() {
			this.$refs.userForm.validate((valid) => {
				if (valid) {
					saveOrUpdatePlatformUser(this.userForm).then((res) => {
						if (res.operationCode == 1) {
							this.$message.success('保存成功！')
							//点击确定后关闭弹框
							this.$emit('handle-success')
						}
					})
				} else {
					this.$message.warning('请完善必填项!')
				}
			})
		},

		//获取用户组
		getGroups() {
			let param = {}
			getAllGroups(param).then((res) => {
				this.groups = res.data
			})
		},

		// 获取角色数据
		getRoleData() {
			let param = {}
			selectRoleTree(param).then((res) => {
				this.roleTreeData = res.data
			})
		},

		//获取岗位
		getStationList() {
			let param = {}
			param.value = '1002'
			getDictsByValue(param).then((res) => {
				this.stationList = res.data
			})
		},

		// 查看、编辑初始渲染数据
		initSysUser() {
			let param = {}
			param.id = this.transObj.id
			getUserInfo(param)
				.then((res) => {
					this.userForm = res.data
				})
				.catch((err) => {})
		},
	},
	created() {
		if (this.transObj.mode != 'add') this.initSysUser()
		this.getRoleData()
		this.getStationList()
		this.getGroups()
	},
	computed: {
		// 公司名称
		type() {
			return getItem('type')
		},
		// 是否可编辑
		isDisabled() {
			return this.transObj.mode === 'view' ? true : false
		},
	},
}
</script>

<style scoped lang="less">
/*
    用scoped + /deep/ 可修改原组件样式 同时不影响全局样式
*/
/deep/ .el-input-group__prepend {
	border-right: none;
}

/deep/ .el-input-group__append {
	background-color: #409eff;
	color: #fff;
	vertical-align: middle;
	display: table-cell;
	position: relative;
	border: 1px solid #dcdfe6;
	padding: 0 20px;
	width: 1px;
	white-space: nowrap;
	border-left: none;
}
</style>
